import React, { useState } from 'react'
import Fade from 'react-reveal/Fade'
import Flip from 'react-reveal/Flip'

import {
  ExpandedHolder,
  ExpandedTextHolder,
  Container,
  Content,
  TextHolder,
  Button,
  CollapseIcon,
  IconBeneficio,
} from './style.css'

import CompromisoExpandableImgURL from '@/images/img-person-02.png'
import CollapseIconURL from '@/images/collapse.svg'

import icon01 from '@/images/iconos/01-acceso-digital-ilimitado.svg'
import icon02 from '@/images/iconos/02-navegacion-sin-popups.svg'
import icon03 from '@/images/iconos/03-papel-digital.svg'
import icon04 from '@/images/iconos/04-early-access.svg'
import icon05 from '@/images/iconos/05-newsletters.svg'
import icon06 from '@/images/iconos/06-podcasts.svg'
import icon07 from '@/images/iconos/07-beneficios-club-la-tercera.svg'

const CompromisoExpandable = () => {
  const [expanded, setExpanded] = useState(false)

  return (
    <Container>
      <Content>
        <img
          className="compromiso-image"
          src={CompromisoExpandableImgURL}
          alt="compromiso"
        />
        <Fade bottom>
          <TextHolder>
            <h2 className="leading-none mb-4">
              Qué incluye una <br />
              suscripción digital.
            </h2>
            <ul>
              <li>
                <IconBeneficio className="iconBeneficio" src={icon01} />
                <p>
                  <strong>
                    Acceso digital ilimitado a los contenidos de La Tercera.com,
                    La Tercera AM, PM y Noche
                  </strong>
                  , Pulso, Pulso PM, Qué Pasa, Culto, Paula y más
                </p>
              </li>
              <li>
                <IconBeneficio className="iconBeneficio" src={icon02} />
                <p>
                  <strong>Navega sin publicidad emergente</strong>
                </p>
              </li>
              <li>
                <IconBeneficio className="iconBeneficio" src={icon03} />
                <p>
                  <strong>
                    Acceso exclusivo a papel digital La Tercera, La Tercera
                    Noche y Conversaciones LT
                  </strong>
                </p>
              </li>
              <li>
                <IconBeneficio className="iconBeneficio" src={icon04} />
                <p>
                  <strong>Early Access La Tercera </strong>(Edición digital
                  disponible en App y Mailing en día anterior desde las 21
                  horas)
                </p>
              </li>
              <li>
                <IconBeneficio className="iconBeneficio" src={icon05} />
                <p>
                  <strong>Acceso a Newsletters</strong>
                </p>
              </li>
              <li>
                <IconBeneficio className="iconBeneficio" src={icon06} />
                <p>
                  <strong>Acceso a Podcast Crónica Estéreo</strong>
                </p>
              </li>
              <li>
                <IconBeneficio className="iconBeneficio" src={icon07} />
                <p>
                  <strong>Beneficios Club La Tercera</strong>
                </p>
              </li>
            </ul>

            <Flip bottom>
              <Button onClick={() => setExpanded(true)}>Leer más</Button>
            </Flip>
          </TextHolder>
        </Fade>
      </Content>
      <ExpandedHolder className={expanded ? 'active' : ''}>
        <CollapseIcon
          src={CollapseIconURL}
          onClick={() => setExpanded(false)}
        />

        <ExpandedTextHolder>
          <p>
            La idea es poner al suscriptor al centro de toda nuestra operación.
          </p>
          <p>
            El desafío impuesto por la tecnología no solo tiene que ver con las
            herramientas técnicas y con los formatos, también nos brinda una
            oportunidad maravillosa de volver a reencontrarnos con nuestros
            lectores.
          </p>
          <p>
            La suscripción digital de La Tercera permite a sus usuarios tomar
            mejores decisiones e informarse con opinión. Levantar una
            suscripción es poner lo mejor de nuestro periodismo a disposición de
            los temas que importan a quienes nos eligen.
          </p>
          <h4>Alejandro Trujillo B.</h4>
          <h5>Director de Audiencias y Plataformas</h5>
        </ExpandedTextHolder>
      </ExpandedHolder>
    </Container>
  )
}

export default CompromisoExpandable
